import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import { getDataAPIAuth, postDataAPI } from '../../utils/API';
import { editProperty } from '../../redux/actions/propertyAction';
import CreatePropertyBlockchain from './DeployNewICO';
import RiyalSymbol from '../RiyalSymbol';
import { VIEW_CONTRACT } from '../../utils/config';
import AdminShell from './AdminShell';
import axios from 'axios';
import DraggableMap from '../Common/DraggableMap';

const DARK = "#0e3725";
const GOLD = "#c9a84c";

const card = {
	background: "#fff",
	borderRadius: 14,
	boxShadow: "0 1px 10px rgba(0,0,0,0.07)",
	overflow: "hidden",
};

const fieldStyle = {
	width: "100%",
	padding: "11px 14px",
	border: "1px solid #d1d5db",
	borderRadius: 9,
	fontSize: 13.5,
	color: "#111827",
	background: "#fff",
	outline: "none",
	boxSizing: "border-box",
	fontFamily: "inherit",
	transition: "border-color 0.2s",
};

const labelStyle = {
	display: "block",
	fontSize: 11.5,
	fontWeight: 700,
	color: "#374151",
	textTransform: "uppercase",
	letterSpacing: "0.06em",
	marginBottom: 6,
};

const errorStyle = {
	display: "block",
	fontSize: 12,
	color: "#dc2626",
	marginTop: 4,
	fontWeight: 500,
};

const EditProperty = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const [blockchaindata, setBlockchainData] = useState("");
	const blockchainFetched = React.useRef(false);
	const [newImages, setNewImages] = useState([]);
	const [imageUploading, setImageUploading] = useState(false);
	const [imageUploadMsg, setImageUploadMsg] = useState('');
	const [newDeed, setNewDeed] = useState(null);
	const [deedUploading, setDeedUploading] = useState(false);
	const [deedUploadMsg, setDeedUploadMsg] = useState('');
	const [activeTab, setActiveTab] = useState('blockchain');
	const { auth, property, ico } = useSelector((state) => state);
	const token = auth?.data?.accesstoken || auth?.data?.access_token;

	if (property.data) {
		var response = property.data;
		if (response.status == 1) {
			response.errors = 0;
			// Stay on the current admin property management page after update
		}
	}

	const initialState = {
		_id: "", title: "", address: "", description: "", descriptionAr: "",
		contract_address: "", tokenPrice: "", imageName: "",
		propertyEstimatedValue: "", status: "", generatic_income: "",
		propertyDeed: "", percentageOfOwnership: "",
		subscriptionStart: "", subscriptionEnd: "",
	};

	const [propertyData, setPropertyData] = useState(initialState);
	const { _id, title, address, description, descriptionAr, contract_address, tokenPrice, imageName, propertyEstimatedValue, status, generatic_income, propertyDeed, percentageOfOwnership, subscriptionStart, subscriptionEnd } = propertyData;

	if (ico.data) {
		var icoResponse = ico.data;
		if (icoResponse.status == 1) {
			getBlockchain(propertyData);
		}
	}

	async function getProperty() {
		var hrefPath = window.location.href;
		var id = hrefPath.split("/")[5];
		getDataAPIAuth("/get_property/" + id, token).then(function (getProperty) {
			getProperty = getProperty.data[0];
			setPropertyData({ ...propertyData, ...getProperty });
		});
	}
	useEffect(() => { if (token) getProperty(); }, [token]);

	const handleChangeInput = (e) => {
		const { name, value } = e.target;
		if (name === "address") {
			document.querySelector(".add_map")?.setAttribute("src", "https://www.google.com/maps/embed/v1/place?key=AIzaSyB1oST8BuCKK4jfZ_Pev5XxBC6_VK1i7Xw&q=" + value);
		}
		setPropertyData({ ...propertyData, [name]: value });
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		dispatch(editProperty(propertyData));
	};

	async function getBlockchain(prop) {
		if (prop._id) {
			await getDataAPIAuth("/getPropBlockchainData/" + prop._id, token).then(function (blockchainData) {
				blockchainData = blockchainData.data[0];
				setBlockchainData(blockchainData);
				if (blockchainData) {
					const autoContractAddress = blockchainData.contractAddress || '';
					const estValue = prop.propertyEstimatedValue || 0;
					const ownershipPct = prop.percentageOfOwnership || 100;
					const supply = blockchainData.totalTokenSupply || prop.totalTokenSupply || 1;
					const autoUnitPrice = supply > 0 ? Math.round((estValue * ownershipPct / 100) / supply) : 0;
					setPropertyData(prev => ({
						...prev,
						contract_address: prev.contract_address || autoContractAddress,
						tokenPrice: prev.tokenPrice || autoUnitPrice,
					}));
				}
			});
		}
	}
	useEffect(() => {
		if (propertyData._id && !blockchainFetched.current) {
			blockchainFetched.current = true;
			getBlockchain(propertyData);
		}
	}, [propertyData._id]);

	const handleDeedUpload = async () => {
		if (!newDeed) return;
		setDeedUploading(true);
		setDeedUploadMsg('');
		try {
			const formData = new FormData();
			formData.append('propertyId', propertyData._id);
			formData.append('deed', newDeed);
			const resp = await axios.post('/api/uploadPropertyDeed', formData, {
				headers: { 'content-type': 'multipart/form-data', 'Authorization': `Bearer ${token}` },
			});
			if (resp.data.status === 1) {
				setPropertyData(prev => ({ ...prev, propertyDeed: resp.data.deed_url }));
				setNewDeed(null);
				setDeedUploadMsg('Deed uploaded successfully!');
			} else {
				setDeedUploadMsg('Upload failed. Please try again.');
			}
		} catch (e) {
			setDeedUploadMsg('Upload error: ' + (e.response?.data?.msg || e.message));
		}
		setDeedUploading(false);
	};

	const handleImageUpload = async () => {
		if (!newImages.length) return;
		setImageUploading(true);
		setImageUploadMsg('');
		try {
			const formData = new FormData();
			formData.append('propertyId', propertyData._id);
			newImages.forEach(img => formData.append('images', img));
			const resp = await axios.post('/api/uploadPropertyImages', formData, {
				headers: { 'content-type': 'multipart/form-data', 'Authorization': `Bearer ${token}` },
			});
			if (resp.data.status === 1) {
				setPropertyData(prev => ({ ...prev, imageName: resp.data.imageName }));
				setNewImages([]);
				setImageUploadMsg('Images updated successfully!');
			} else {
				setImageUploadMsg('Upload failed. Please try again.');
			}
		} catch (e) {
			setImageUploadMsg('Upload error: ' + (e.response?.data?.msg || e.message));
		}
		setImageUploading(false);
	};

	const tabs = [
		{
			id: 'blockchain',
			label: 'Create Property Blockchain',
			icon: (
				<svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
					<rect x="2" y="7" width="6" height="6" rx="1" /><rect x="16" y="7" width="6" height="6" rx="1" />
					<rect x="9" y="14" width="6" height="6" rx="1" />
					<line x1="5" y1="13" x2="5" y2="17" /><line x1="5" y1="17" x2="12" y2="17" />
					<line x1="19" y1="13" x2="19" y2="17" /><line x1="19" y1="17" x2="12" y2="17" />
				</svg>
			),
		},
		{
			id: 'edit',
			label: 'Edit Property',
			icon: (
				<svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
					<path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
					<path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
				</svg>
			),
		},
		{
			id: 'evaluations',
			label: 'Evaluations',
			icon: (
				<svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
					<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
					<polyline points="22 4 12 14.01 9 11.01" />
				</svg>
			),
		},
		{
			id: 'expenses',
			label: 'Expenses',
			icon: (
				<svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
					<line x1="12" y1="1" x2="12" y2="23" />
					<path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
				</svg>
			),
		},
		{
			id: 'report',
			label: 'Quarterly Report',
			icon: (
				<svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
					<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
					<polyline points="14 2 14 8 20 8" />
					<line x1="16" y1="13" x2="8" y2="13" />
					<line x1="16" y1="17" x2="8" y2="17" />
				</svg>
			),
		},
	];

	return (
		<AdminShell pageTitle="Property Management">
			{/* Breadcrumb */}
			<div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 24, fontSize: 13, color: "#6b7280" }}>
				<Link to="/admin/properties" style={{ color: "#6b7280", textDecoration: "none" }}>Properties</Link>
				<svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
					<polyline points="9 18 15 12 9 6" />
				</svg>
				<span style={{ color: "#111827", fontWeight: 600 }}>{title || "Property Detail"}</span>
			</div>

			{/* Property header card */}
			<div style={{ ...card, padding: "20px 24px", marginBottom: 24, display: "flex", alignItems: "center", gap: 16, borderLeft: `4px solid ${GOLD}` }}>
				<div style={{ width: 44, height: 44, borderRadius: 10, background: `linear-gradient(135deg, ${DARK} 0%, #1a5c3a 100%)`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
					<svg width="22" height="22" fill="none" stroke="#fff" strokeWidth="1.8" viewBox="0 0 24 24">
						<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
						<polyline points="9 22 9 12 15 12 15 22" />
					</svg>
				</div>
				<div style={{ flex: 1, minWidth: 0 }}>
					<h2 style={{ margin: 0, fontSize: 17, fontWeight: 800, color: DARK, fontFamily: "'Ibarra Real Nova', serif" }}>{title || "Loading…"}</h2>
					<p style={{ margin: "3px 0 0", fontSize: 12.5, color: "#6b7280" }}>{address || "No address set"}</p>
				</div>
				{blockchaindata ? (
					<span style={{ padding: "5px 14px", borderRadius: 20, fontSize: 11.5, fontWeight: 700, background: "rgba(22,163,74,0.1)", color: "#15803d", border: "1px solid rgba(22,163,74,0.2)", whiteSpace: "nowrap" }}>
						✓ Token Deployed
					</span>
				) : (
					<span style={{ padding: "5px 14px", borderRadius: 20, fontSize: 11.5, fontWeight: 700, background: "rgba(201,168,76,0.1)", color: "#92400e", border: "1px solid rgba(201,168,76,0.25)", whiteSpace: "nowrap" }}>
						⏳ Awaiting Deployment
					</span>
				)}
			</div>

			{/* Custom tabs */}
			<div style={{ display: "flex", gap: 0, marginBottom: 0, borderBottom: `2px solid #e5e7eb` }}>
				{tabs.map((tab) => (
					<button
						key={tab.id}
						onClick={() => setActiveTab(tab.id)}
						style={{
							padding: "12px 22px",
							fontSize: 13.5,
							fontWeight: 600,
							border: "none",
							background: "transparent",
							cursor: "pointer",
							display: "flex",
							alignItems: "center",
							gap: 8,
							color: activeTab === tab.id ? DARK : "#6b7280",
							borderBottom: activeTab === tab.id ? `2px solid ${GOLD}` : "2px solid transparent",
							marginBottom: -2,
							transition: "color 0.15s",
						}}
					>
						{tab.icon}
						{tab.label}
					</button>
				))}
			</div>

			{/* Tab content */}
			<div style={{ ...card, borderTopLeftRadius: 0, borderTopRightRadius: 0, padding: "28px 28px" }}>

				{/* ── BLOCKCHAIN TAB ── */}
				{activeTab === 'blockchain' && (
					<div>
						{/* Due Diligence — Deed review, always visible */}
						<div style={{ marginBottom: 24, padding: "16px 20px", borderRadius: 10, background: "#f9fafb", border: "1px solid #e5e7eb" }}>
							<p style={{ margin: "0 0 10px", fontSize: 11, fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.06em" }}>Due Diligence — Property Deed</p>
							{propertyDeed && propertyDeed.startsWith('http') ? (
								<a href={propertyDeed} target="_blank" rel="noreferrer"
									style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "9px 16px", borderRadius: 8, background: "#f0fdf4", border: "1px solid #bbf7d0", color: "#065f46", fontSize: 13, fontWeight: 600, textDecoration: "none" }}>
									<svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /></svg>
									View Property Deed
								</a>
							) : propertyDeed ? (
								<span style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "9px 16px", borderRadius: 8, background: "#fef9c3", border: "1px solid #fde047", color: "#854d0e", fontSize: 13, fontWeight: 600 }}>
									<svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
									Old deed file — go to Edit Property tab to re-upload
								</span>
							) : (
								<span style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "9px 16px", borderRadius: 8, background: "rgba(239,68,68,0.07)", border: "1px solid rgba(239,68,68,0.2)", color: "#dc2626", fontSize: 13, fontWeight: 600 }}>
									<svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
									No deed uploaded — go to Edit Property tab to upload before deploying
								</span>
							)}
						</div>

						{blockchaindata ? (
							<div>
								{/* Deployed token info */}
								<div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 24 }}>
									<div style={{ width: 42, height: 42, borderRadius: 10, background: "rgba(22,163,74,0.1)", display: "flex", alignItems: "center", justifyContent: "center" }}>
										<svg width="20" height="20" fill="none" stroke="#15803d" strokeWidth="2" viewBox="0 0 24 24">
											<polyline points="20 6 9 17 4 12" />
										</svg>
									</div>
									<div>
										<h3 style={{ margin: 0, fontSize: 16, fontWeight: 800, color: "#111827", fontFamily: "'Ibarra Real Nova', serif" }}>
											{blockchaindata.contractName}
											<span style={{ marginLeft: 10, fontSize: 13, fontWeight: 600, color: GOLD }}>({blockchaindata.symbol})</span>
										</h3>
										<p style={{ margin: "2px 0 0", fontSize: 12, color: "#6b7280" }}>
											{blockchaindata.network || 'BSC Testnet'} &bull; Chain ID: {blockchaindata.chainId || 97}
										</p>
									</div>
								</div>

								{/* Token data grid */}
								<div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 20 }}>
									{[
										{ label: "Token Symbol", value: blockchaindata.symbol },
										{ label: "Token Standard", value: blockchaindata.tokenStandard || "BEP-20" },
										{ label: "Total Token Supply", value: Number(blockchaindata.totalTokenSupply).toLocaleString() },
											{ label: "Deployed At", value: new Date(blockchaindata.createdAt).toLocaleString() },
										{ label: "Network", value: blockchaindata.network || "BSC Testnet" },
									].map((item) => (
										<div key={item.label} style={{ background: "#f9fafb", borderRadius: 9, padding: "12px 16px", border: "1px solid #f3f4f6" }}>
											<p style={{ margin: 0, fontSize: 11, fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.06em" }}>{item.label}</p>
											<p style={{ margin: "4px 0 0", fontSize: 14, fontWeight: 600, color: "#111827" }}>{item.value}</p>
										</div>
									))}
								</div>

								{/* Contract address */}
								<div style={{ background: "#f9fafb", borderRadius: 9, padding: "14px 16px", border: "1px solid #f3f4f6", marginBottom: 12 }}>
									<p style={{ margin: "0 0 5px", fontSize: 11, fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.06em" }}>Contract Address (Token ID)</p>
									<a href={`${VIEW_CONTRACT}token/${blockchaindata.contractAddress}`} target="_blank" rel="noreferrer"
										style={{ fontSize: 13, color: DARK, fontFamily: "monospace", wordBreak: "break-all", fontWeight: 600, textDecoration: "none" }}>
										{blockchaindata.contractAddress}
									</a>
								</div>

								{/* Transaction hash */}
								<div style={{ background: "#f9fafb", borderRadius: 9, padding: "14px 16px", border: "1px solid #f3f4f6", marginBottom: 24 }}>
									<p style={{ margin: "0 0 5px", fontSize: 11, fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.06em" }}>Transaction Hash</p>
									<a href={`${VIEW_CONTRACT}tx/${blockchaindata.transactionHash}`} target="_blank" rel="noreferrer"
										style={{ fontSize: 13, color: DARK, fontFamily: "monospace", wordBreak: "break-all", fontWeight: 600, textDecoration: "none" }}>
										{blockchaindata.transactionHash}
									</a>
								</div>

								{/* Action buttons */}
								<div style={{ display: "flex", gap: 12 }}>
									<a href={`${VIEW_CONTRACT}token/${blockchaindata.contractAddress}`} target="_blank" rel="noreferrer"
										style={{ padding: "10px 20px", borderRadius: 9, fontSize: 13, fontWeight: 700, background: `linear-gradient(135deg, ${GOLD} 0%, #b8943e 100%)`, color: "#fff", textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 7, boxShadow: "0 3px 10px rgba(201,168,76,0.3)" }}>
										<svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" /><polyline points="15 3 21 3 21 9" /><line x1="10" y1="14" x2="21" y2="3" /></svg>
										View Token on BSCScan
									</a>
									<a href={`${VIEW_CONTRACT}tx/${blockchaindata.transactionHash}`} target="_blank" rel="noreferrer"
										style={{ padding: "10px 20px", borderRadius: 9, fontSize: 13, fontWeight: 700, background: "#fff", color: DARK, border: `1.5px solid ${DARK}`, textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 7 }}>
										<svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" /><polyline points="15 3 21 3 21 9" /><line x1="10" y1="14" x2="21" y2="3" /></svg>
										View Transaction
									</a>
								</div>
							</div>
						) : (
							<CreatePropertyBlockchain data={propertyData} />
						)}
					</div>
				)}

				{/* ── EDIT PROPERTY TAB ── */}
				{activeTab === 'edit' && (
					<div>
						{/* Property Deed — always visible regardless of blockchain status */}
						<div style={{ marginBottom: 24 }}>
							<label style={labelStyle}>Property Deed</label>
							{propertyDeed && propertyDeed.startsWith('http') ? (
								<a href={propertyDeed} target="_blank" rel="noreferrer"
									style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "9px 16px", borderRadius: 8, background: "#f0fdf4", border: "1px solid #bbf7d0", color: "#065f46", fontSize: 13, fontWeight: 600, textDecoration: "none", marginBottom: 12 }}>
									<svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /></svg>
									View Property Deed
								</a>
							) : propertyDeed ? (
								<div style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "9px 16px", borderRadius: 8, background: "#fef9c3", border: "1px solid #fde047", color: "#854d0e", fontSize: 13, fontWeight: 600, marginBottom: 12 }}>
									<svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
									Old deed file no longer accessible — please re-upload below
								</div>
							) : (
								<div style={{ fontSize: 13, color: "#9ca3af", marginBottom: 12 }}>No deed uploaded yet</div>
							)}
							<div style={{ border: "2px dashed #d1d5db", borderRadius: 10, padding: "14px 18px", background: "#f9fafb" }}>
								<label style={{ display: "block", marginBottom: 8, fontWeight: 600, fontSize: 12.5, color: "#374151" }}>
									{propertyDeed && propertyDeed.startsWith('http') ? 'Replace Deed' : 'Upload Deed'}
								</label>
								<input type="file" accept=".pdf,.doc,.docx,application/pdf,application/msword" style={{ marginBottom: 10, fontSize: 13 }}
									onChange={(e) => setNewDeed(e.target.files[0] || null)} />
								{newDeed && (
									<div style={{ fontSize: 12.5, color: "#374151", marginBottom: 8 }}>Selected: {newDeed.name}</div>
								)}
								<button type="button" onClick={handleDeedUpload} disabled={deedUploading || !newDeed}
									style={{ background: !newDeed ? "#e5e7eb" : DARK, color: !newDeed ? "#9ca3af" : "#fff", border: "none", borderRadius: 8, padding: "9px 20px", fontWeight: 600, fontSize: 13, cursor: !newDeed ? "not-allowed" : "pointer" }}>
									{deedUploading ? 'Uploading…' : 'Upload Deed'}
								</button>
								{deedUploadMsg && (
									<div style={{ marginTop: 8, fontSize: 13, color: deedUploadMsg.includes('success') ? "#065f46" : "#991b1b", fontWeight: 600 }}>
										{deedUploadMsg}
									</div>
								)}
							</div>
						</div>

					<form onSubmit={handleSubmit}>
								<div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 20 }}>
									{/* Title */}
									<div>
										<label style={labelStyle}>Title</label>
										<input type="text" style={{ ...fieldStyle, background: "#f9fafb", color: "#6b7280" }} name="title" value={title} readOnly />
										<span style={errorStyle}>{property.data ? property.data.errors.title : ""}</span>
									</div>
									{/* Address */}
									<div>
										<label style={labelStyle}>Address</label>
										<input type="text" style={fieldStyle} name="address" value={address} placeholder="Address" onChange={handleChangeInput}
											onFocus={(e) => (e.target.style.borderColor = GOLD)}
											onBlur={(e) => (e.target.style.borderColor = "#d1d5db")} />
										<span style={errorStyle}>{property.data ? property.data.errors.address : ""}</span>
									</div>
								</div>

								{/* Map — draggable pin with reverse geocoding */}
								<DraggableMap
									lat={propertyData._mapLat || 24.7136}
									lng={propertyData._mapLng || 46.6753}
									address={address}
									onLocationChange={({ lat, lng, address: newAddr, city: newCity }) => {
										setPropertyData((prev) => ({ ...prev, address: newAddr, city: newCity || prev.city, _mapLat: lat, _mapLng: lng }));
									}}
									height="260px"
								/>

							{/* Description Arabic */}
							<div style={{ marginBottom: 20 }}>
								<label style={labelStyle}>Description — Arabic <span style={{ color: '#e05252' }}>*</span></label>
								<textarea
									style={{ ...fieldStyle, minHeight: 90, resize: "vertical", direction: "rtl", fontFamily: "'Tajawal', sans-serif" }}
									name="descriptionAr"
									value={descriptionAr}
									placeholder="صف العقار ومميزاته وفرص الاستثمار..."
									onChange={handleChangeInput}
									onFocus={(e) => (e.target.style.borderColor = GOLD)}
									onBlur={(e) => (e.target.style.borderColor = "#d1d5db")}
								/>
							</div>
							{/* Description English */}
							<div style={{ marginBottom: 20 }}>
								<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
									<label style={labelStyle}>Description — English</label>
									<button
										type="button"
										style={{ fontSize: 11, color: '#0e3725', background: 'none', border: `1px solid ${GOLD}`, borderRadius: 6, padding: '3px 10px', cursor: 'pointer', fontWeight: 700 }}
										onClick={async () => {
											if (!descriptionAr) return;
											try {
												const res = await fetch(`https://api.mymemory.translated.net/get?q=${encodeURIComponent(descriptionAr)}&langpair=ar|en`);
												const data = await res.json();
												if (data.responseStatus === 200) {
													setPropertyData(prev => ({ ...prev, description: data.responseData.translatedText }));
												}
											} catch (e) { /* silent */ }
										}}
									>
										⇆ Auto-translate from Arabic
									</button>
								</div>
								<textarea style={{ ...fieldStyle, minHeight: 90, resize: "vertical" }} name="description" value={description} placeholder="Description (English)" onChange={handleChangeInput}
									onFocus={(e) => (e.target.style.borderColor = GOLD)}
									onBlur={(e) => (e.target.style.borderColor = "#d1d5db")} />
								<span style={errorStyle}>{property.data ? property.data.errors.description : ""}</span>
							</div>

								<div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 20 }}>
									{/* Contract Address */}
									<div>
										<label style={labelStyle}>Contract Address</label>
										<input type="text" style={fieldStyle} name="contract_address" value={contract_address} placeholder="0x..." onChange={handleChangeInput}
											onFocus={(e) => (e.target.style.borderColor = GOLD)}
											onBlur={(e) => (e.target.style.borderColor = "#d1d5db")} />
										<span style={errorStyle}>{property.data ? property.data.errors.contract_address : ""}</span>
									</div>
									{/* Unit Price */}
									<div>
										<label style={labelStyle}>Unit Price (SAR)</label>
										<input type="text" style={fieldStyle} name="tokenPrice" value={tokenPrice} placeholder="Unit Price" onChange={handleChangeInput}
											onFocus={(e) => (e.target.style.borderColor = GOLD)}
											onBlur={(e) => (e.target.style.borderColor = "#d1d5db")} />
										<span style={errorStyle}>{property.data ? property.data.errors.tokenPrice : ""}</span>
									</div>
								</div>

								<div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 20 }}>
									{/* Estimated Value */}
									<div>
										<label style={labelStyle}>Estimated Value (SAR/m²)</label>
										<input type="text" style={fieldStyle} name="propertyEstimatedValue" value={propertyEstimatedValue} placeholder="Estimated Value" onChange={handleChangeInput}
											onFocus={(e) => (e.target.style.borderColor = GOLD)}
											onBlur={(e) => (e.target.style.borderColor = "#d1d5db")} />
										<span style={errorStyle}>{property.data ? property.data.errors.propertyEstimatedValue : ""}</span>
									</div>
									{/* Ownership % */}
									<div>
										<label style={labelStyle}>Percentage of Ownership (%)</label>
										<input type="text" style={fieldStyle} name="percentageOfOwnership" value={percentageOfOwnership} placeholder="e.g. 100" onChange={handleChangeInput}
											onFocus={(e) => (e.target.style.borderColor = GOLD)}
											onBlur={(e) => (e.target.style.borderColor = "#d1d5db")} />
										<span style={errorStyle}>{property.data ? property.data.errors.percentageOfOwnership : ""}</span>
									</div>
								</div>

								{/* Generatic Income */}
								<div style={{ marginBottom: 20 }}>
									<label style={labelStyle}>Generates Income</label>
									<div style={{ display: "flex", gap: 16, marginTop: 4 }}>
										{[{ val: "1", label: "Yes" }, { val: "0", label: "No" }].map((opt) => (
											<label key={opt.val} style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", fontSize: 13.5, fontWeight: 500, color: "#374151" }}>
												<input type="radio" name="generatic_income" value={opt.val} checked={generatic_income == opt.val} onChange={handleChangeInput}
													style={{ accentColor: GOLD, width: 16, height: 16 }} />
												{opt.label}
											</label>
										))}
									</div>
									<span style={errorStyle}>{property.data ? property.data.errors.generatic_income : ""}</span>
								</div>

								{/* Images */}
								<div style={{ marginBottom: 20 }}>
									<label style={labelStyle}>Property Images</label>
									<div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 14 }}>
										{imageName && imageName.length > 0 ? imageName.map((img, idx) => (
											<img key={idx} src={img} alt="Property"
												style={{ width: 140, height: 95, objectFit: "cover", borderRadius: 8, border: "2px solid #e5e7eb" }}
												onError={(e) => { e.target.style.display = "none"; }} />
										)) : <span style={{ color: "#9ca3af", fontSize: 13 }}>No images yet</span>}
									</div>
									<div style={{ border: "2px dashed #d1d5db", borderRadius: 10, padding: "16px 20px", background: "#f9fafb" }}>
										<label style={{ display: "block", marginBottom: 8, fontWeight: 600, fontSize: 12.5, color: "#374151" }}>Replace Images</label>
										<input type="file" multiple accept="image/*" style={{ marginBottom: 10, fontSize: 13 }} onChange={(e) => setNewImages(Array.from(e.target.files))} />
										{newImages.length > 0 && (
											<div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 10 }}>
												{newImages.map((f, i) => (
													<img key={i} src={URL.createObjectURL(f)} alt="preview"
														style={{ width: 90, height: 65, objectFit: "cover", borderRadius: 6, border: `2px solid ${GOLD}` }} />
												))}
											</div>
										)}
										<button type="button" onClick={handleImageUpload} disabled={imageUploading || newImages.length === 0}
											style={{ background: newImages.length === 0 ? "#e5e7eb" : DARK, color: newImages.length === 0 ? "#9ca3af" : "#fff", border: "none", borderRadius: 8, padding: "9px 20px", fontWeight: 600, fontSize: 13, cursor: newImages.length === 0 ? "not-allowed" : "pointer" }}>
											{imageUploading ? "Uploading…" : `Upload ${newImages.length > 0 ? `(${newImages.length} file${newImages.length > 1 ? "s" : ""})` : "Images"}`}
										</button>
										{imageUploadMsg && (
											<div style={{ marginTop: 8, fontSize: 13, color: imageUploadMsg.includes("success") ? "#065f46" : "#991b1b", fontWeight: 600 }}>
												{imageUploadMsg}
											</div>
										)}
									</div>
								</div>

								{/* Status */}
								<div style={{ marginBottom: 24 }}>
									<label style={labelStyle}>Status</label>
									<select style={{ ...fieldStyle, cursor: "pointer" }} name="status" value={status} onChange={handleChangeInput}
										onFocus={(e) => (e.target.style.borderColor = GOLD)}
										onBlur={(e) => (e.target.style.borderColor = "#d1d5db")}>
										<option value="">-- Select --</option>
										<option value="1">Active</option>
										<option value="0">Inactive</option>
									</select>
									<span style={errorStyle}>{property.data ? property.data.errors.status : ""}</span>
								</div>

							{/* Subscription Timeframe */}
							<div style={{ marginBottom: 24 }}>
								<label style={labelStyle}>Subscription Timeframe</label>
								<p style={{ fontSize: 12, color: '#6b7280', marginBottom: 12, marginTop: 0 }}>Set the listing subscription period. This must be filled when approving a property.</p>
								<div style={{ display: 'flex', gap: 12 }}>
									<div style={{ flex: 1 }}>
										<label style={{ ...labelStyle, fontSize: 11, marginBottom: 4 }}>Start Date</label>
										<input
											type="date"
											style={{ ...fieldStyle }}
											name="subscriptionStart"
											value={subscriptionStart ? subscriptionStart.substring(0, 10) : ''}
											onChange={handleChangeInput}
											onFocus={(e) => (e.target.style.borderColor = GOLD)}
											onBlur={(e) => (e.target.style.borderColor = '#d1d5db')}
										/>
									</div>
									<div style={{ flex: 1 }}>
										<label style={{ ...labelStyle, fontSize: 11, marginBottom: 4 }}>End Date</label>
										<input
											type="date"
											style={{ ...fieldStyle }}
											name="subscriptionEnd"
											value={subscriptionEnd ? subscriptionEnd.substring(0, 10) : ''}
											onChange={handleChangeInput}
											onFocus={(e) => (e.target.style.borderColor = GOLD)}
											onBlur={(e) => (e.target.style.borderColor = '#d1d5db')}
										/>
									</div>
								</div>
								{subscriptionStart && subscriptionEnd && (
									<div style={{ marginTop: 8, padding: '8px 12px', background: '#f0fdf4', borderRadius: 8, fontSize: 12, color: '#166534', border: '1px solid #bbf7d0' }}>
										✓ Subscription period: {new Date(subscriptionStart).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })} – {new Date(subscriptionEnd).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}
									</div>
								)}
							</div>

							{/* Submit */}
							<button type="submit"
									style={{ padding: "13px 32px", background: `linear-gradient(135deg, ${GOLD} 0%, #b8943e 100%)`, color: "#fff", border: "none", borderRadius: 10, fontSize: 14, fontWeight: 700, cursor: "pointer", boxShadow: "0 4px 14px rgba(201,168,76,0.35)", display: "inline-flex", alignItems: "center", gap: 8 }}
									onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-1px)"; }}
									onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; }}>
									<svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" /></svg>
									Update Property
								</button>
						</form>
					</div>
				)}

			{/* Evaluations Tab */}
			{activeTab === 'evaluations' && (
				<div style={{ marginTop: 24 }}>
					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
						<div>
							<h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#111827' }}>Property Evaluations</h3>
							<p style={{ margin: '4px 0 0', fontSize: 13, color: '#6b7280' }}>Bi-annual licensed evaluations — average of two evaluators</p>
						</div>
						<a
							href={`/admin/evaluations/${_id}`}
							style={{ padding: '9px 18px', background: `linear-gradient(135deg,${GOLD},#7a5c10)`, color: '#fff', borderRadius: 8, fontSize: 13, fontWeight: 700, textDecoration: 'none', display: 'inline-block' }}
						>
							Manage Evaluations →
						</a>
					</div>
					<div style={{ background: '#f9fafb', borderRadius: 10, padding: '20px 24px', border: '1px solid #e5e7eb', fontSize: 13, color: '#6b7280' }}>
						Click "Manage Evaluations" to add, view, and manage bi-annual property valuations from licensed evaluators. The system automatically calculates the average of both evaluations.
					</div>
				</div>
			)}

			{/* Expenses Tab */}
			{activeTab === 'expenses' && (
				<div style={{ marginTop: 24 }}>
					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
						<div>
							<h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#111827' }}>Property Expenses</h3>
							<p style={{ margin: '4px 0 0', fontSize: 13, color: '#6b7280' }}>Facility management, maintenance, insurance, and other property expenses</p>
						</div>
						<a
							href={`/admin/expenses/${_id}`}
							style={{ padding: '9px 18px', background: `linear-gradient(135deg,${GOLD},#7a5c10)`, color: '#fff', borderRadius: 8, fontSize: 13, fontWeight: 700, textDecoration: 'none', display: 'inline-block' }}
						>
							Manage Expenses →
						</a>
					</div>
					<div style={{ background: '#f9fafb', borderRadius: 10, padding: '20px 24px', border: '1px solid #e5e7eb', fontSize: 13, color: '#6b7280' }}>
						Click "Manage Expenses" to log property expenses by type (maintenance, facility management, insurance, etc.). Expense types are shared across all properties.
					</div>
				</div>
			)}

			{/* Quarterly Report Tab */}
			{activeTab === 'report' && (
				<div style={{ marginTop: 24 }}>
					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
						<div>
							<h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#111827' }}>Quarterly Investor Report</h3>
							<p style={{ margin: '4px 0 0', fontSize: 13, color: '#6b7280' }}>Generate printable PDF reports for investors with evaluations, expenses, P&L, and token metrics</p>
						</div>
						<a
							href={`/admin/report/${_id}`}
							style={{ padding: '9px 18px', background: `linear-gradient(135deg,${GOLD},#7a5c10)`, color: '#fff', borderRadius: 8, fontSize: 13, fontWeight: 700, textDecoration: 'none', display: 'inline-block' }}
						>
							Generate Report →
						</a>
					</div>
					<div style={{ background: '#f9fafb', borderRadius: 10, padding: '20px 24px', border: '1px solid #e5e7eb', fontSize: 13, color: '#6b7280' }}>
						Click "Generate Report" to create a quarterly investor report that includes: latest property evaluation, period expenses, dividend distributions, unrealized P&L, and intrinsic token value. The report can be printed or saved as PDF.
					</div>
				</div>
			)}

		</div>
	</AdminShell>
	);
};

export default EditProperty;
